import { ExportOutlined, RedoOutlined, TagsOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useAuth } from "@/context/AuthContext";
import { hasSectionActiveTask } from "@/utility/sectionTaskState";

function SectionGeneratorActionButtons({
  generatedSections,
  section,
  sectionEvalStatus,
  setQualityCheckDialogContent,
  setSectionDialogContent,
  setQualityCheckDialogOpen,
  outputDecision,
  handleRegenerate,
  setSourceDialogContent,
  setSourceDialogOpen,
  toggleSectionTags,
  isSectionTagsOpen,
  showTagButton = true,
}) {
  const { isSuperAdmin } = useAuth();
  const isGeneratedSection = generatedSections.some((s) => s.id === section.id);
  const isDecisionPending = outputDecision[section.id] === true;
  const matchedSection = generatedSections.find((s) => s.id === section.id);
  const sectionHasActiveTask = hasSectionActiveTask(matchedSection);
  const traceUrl =
    (typeof matchedSection?.trace_url === "string" && matchedSection.trace_url.trim().length > 0
      ? matchedSection.trace_url
      : typeof section?.trace_url === "string" && section.trace_url.trim().length > 0
      ? section.trace_url
      : null);
  const hasError =
    !sectionHasActiveTask &&
    (matchedSection?.agentUpdates || []).some((update) =>
      ["error", "failed", "cancelled"].includes(String(update?.status || "").toLowerCase())
    );

  return (
    <>
      {!isGeneratedSection && showTagButton && (
        <Tooltip title="View Tags">
          <button
            type="button"
            aria-label="View Tags"
            aria-expanded={isSectionTagsOpen}
            onClick={(event) => {
              event.stopPropagation();
              toggleSectionTags(section.id);
            }}
            className={`section_generator_panel_icon_button section_generator_panel_icon_button_overlay ${
              isSectionTagsOpen ? "active" : ""
            }`}
          >
            <TagsOutlined />
          </button>
        </Tooltip>
      )}
      {isGeneratedSection && (
        <>
          {!isDecisionPending && (outputDecision[section.id] === false || hasError) && (
            <Tooltip title="Regenerate Section">
              <button
                type="button"
                onClick={() => handleRegenerate(section)}
                className="section_generator_panel_button_default"
              >
                <RedoOutlined />
              </button>
            </Tooltip>
          )}
          {isSuperAdmin && traceUrl && (
            <Tooltip title="Open Trace">
              <button
                type="button"
                onClick={() => window.open(traceUrl, "_blank", "noopener,noreferrer")}
                className="section_generator_panel_button_default"
              >
                <ExportOutlined />
              </button>
            </Tooltip>
          )}
          {showTagButton && (
            <Tooltip title="View Tags">
              <button
                type="button"
                aria-label="View Tags"
                aria-expanded={isSectionTagsOpen}
                onClick={(event) => {
                  event.stopPropagation();
                  toggleSectionTags(section.id);
                }}
                className={`section_generator_panel_button_default ${isSectionTagsOpen ? "active" : ""}`}
              >
                <TagsOutlined />
              </button>
            </Tooltip>
          )}
        </>
      )}
    </>
  );
}

export default SectionGeneratorActionButtons;
